<template>
  <div class="ap-number-search-single main-width">
    <div>
      <ol class="breadcrumb ap-breadcrumb">
        <li class="breadcrumb-item">搜索</li>
        <li class="breadcrumb-item active">查询号码“{{dispWord}}”</li>
      </ol>
    </div>
    <div class="clearfix">
      <div style="float:left;width:180px;">
        <div style="margin-bottom:25px;font-size: 20px">
          <strong>属性筛选</strong>
        </div>
        <strong>品牌</strong>
        <hr />
        <div class="filter-wrap">
          <div class="item" v-for="(it,idx) in brands" :key="it.id">
            <div class="custom-control custom-control-inline custom-checkbox">
              <input type="checkbox" class="custom-control-input" :id="'ckb' + idx" :value="it.id" v-model="brandIds" />
              <label class="custom-control-label" :for="'ckb' + idx">{{it.name}}</label>
            </div>
          </div>
        </div>
        <strong>类目</strong>
        <hr />
        <div class="filter-wrap">
          <div class="item" v-for="(it,idx) in genCmdties" :key="it.id">
            <div class="custom-control custom-control-inline custom-checkbox">
              <input type="checkbox" class="custom-control-input" :id="'gcckb' + idx" :value="it.id" v-model="genCmdtyIds" />
              <label class="custom-control-label" :for="'gcckb' + idx">{{it.name}}</label>
            </div>
          </div>
          <div>
            <button class="ap-btn-red" @click="search">筛选</button>
          </div>
        </div>
      </div>
      <div style="margin-left:240px;min-height:500px">
        <div style="font-size:20px">
          <strong>
            查询
            <strong style="color:#FF0033">{{this.dispWord}}</strong> 结果
          </strong>
        </div>
        <div class="prod-item clearfix" v-for="it in records" :key="it.id">
          <div v-if="!it.showPkg">
            <router-link class="float-left col-img" target="_blank" :to="'/sku/'+it.sourceId">
              <template v-if="it.documentList&&it.documentList[0]&&it.documentList[0].fileUri">
                <img class="img" :src="getImgUrl(it.documentList[0].fileUri)" alt />
              </template>
              <img class="img" v-else src="@assets/images/no_image.png" alt />
            </router-link>
            <div class="number">
              <router-link target="_blank" :to="'/sku/'+it.sourceId">
                <strong>{{it.name}}</strong>
              </router-link>
            </div>
            <div class="float-left col-number filter-item" style="width:500px">
              <div class="out" v-for="it2 in it.vehBrdLinkageList" :key="it2.sourceId">
                <div class="out-tit" @click="getChildren(it,it2)">
                  <img class="img" v-if="!it2.show" src="@assets/icons/add.gif" />
                  <img class="img" v-else src="@assets/icons/reduce.gif" />
                  <span class="text">{{it2.name}}</span>
                </div>
                <template v-for="it3 in it2.children">
                  <div v-if="it2.show" class="inner" :key="it3.sourceId">
                    <div class="inner-tit" style="font-size:12px">
                      <span>{{it3.modelName}}</span>
                      <span v-if="it3.modelNumber">( {{it3.modelNumber}} )</span>
                      <span v-if="it3.modelYears">&nbsp;&nbsp;&nbsp;&nbsp;( {{it3.modelYears.valueKey}} )</span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="float-left col-props">
              <div class="prop-item" v-for="(item,index) in it.criteriaList" v-show="(index < 5) ? true : false" :key="item.genCriSourceId">
                <span>{{item.genCriName}}</span>
                <strong v-if="item.genCriValueType == 'ENUM'">{{item.enumValueName}}</strong>
                <strong v-if="item.genCriValueType == 'STRING'">{{item.stringValue}}</strong>
                <strong v-if="item.genCriValueType == 'NUMERIC'">{{item.numberValue}}{{item.unit}}</strong>
              </div>
            </div>
            <div class="float-right col-actions">
              <div class="price" v-show="it.price&&it.price!=0">￥{{it.price | toMoney}}</div>
              <button v-if="(it.loadingPackagingList.length||it.singleOrder)&&it.supply&&(it.price>0)" class="ap-btn-red add-car" @click="showPkg(it.id), initCart(it)">加入采购车</button>
              <button v-else class="ap-btn-darkgray" style="width:105px; cursor:auto">暂无法供应</button>
              <button v-if="(it.loadingPackagingList.length||it.singleOrder)&&it.supply&&(it.price>0)" class="ap-btn-red add-list" @click="addToList(it)">加入零件清单</button>
            </div>
          </div>
          <div v-else>
            <router-link class="float-left col-img" target="_blank" :to="'/sku/'+it.sourceId">
              <template v-if="it.documentList&&it.documentList[0]&&it.documentList[0].fileUri">
                <img class="img" :src="getImgUrl(it.documentList[0].fileUri)" alt />
              </template>
              <img class="img" v-else src="@assets/images/no_image.png" alt />
            </router-link>
            <div class="number">
              <router-link target="_blank" :to="'/sku/'+it.sourceId">
                <strong>{{it.name}}</strong>
              </router-link>
            </div>
            <div class="float-left col-number">
              <div class="brand">
                <strong>{{it.brandName}}</strong>
              </div>
              <div class="genart">{{it.genCmdtyName}}</div>
              <div class="r90">{{it.brandCertificateList.join(', ')}}</div>
            </div>
            <div class="package-info" ref="packageinfo">
              <p class="tit-wrap">
                <span class="title">选择规格</span>
                <span class="count-title">采购数量</span>
              </p>
              <div class="count">
                <div class="add-to-car">
                  <span style="display:inline-block;margin:8px 10px 0 0;color:#f03">
                    <strong>{{entry.layQty}}件 ×</strong>
                  </span>
                  <InputNumber :min="1" :value.sync="qty"></InputNumber>
                </div>
              </div>
              <div class="wrapper">
                <Slider :boxWidth="400" :moveWidth="300">
                  <div
                    class="multi"
                    v-for="item in it.loadingPackagingList"
                    :key="item.uuid"
                    :class="{'picked': entry.pkgUuid == item.uuid}"
                    @click="entry.commodityId = it.id, entry.pkgUuid=item.uuid, entry.layQty=item.layQty"
                  >
                    <a class="font12">
                      <strong style="color:#f03;">{{item.layQty}}</strong>&nbsp;
                      <span style="color:#333;">{{item.layQtyUnit}}</span>
                      <div style>{{item.pkgName}}</div>
                      <div>
                        {{item.dimLen}}{{item.dimUnit}}x{{item.dimWid}}{{item.dimUnit}}
                        <br />
                        x{{item.dimHig}}{{item.dimUnit}}
                      </div>
                    </a>
                  </div>
                  <div
                    class="single"
                    v-if="it.singleOrder == true"
                    :class="{'picked': entry.pkgUuid == it.pkgUuid}"
                    @click="entry.commodityId = it.id, entry.pkgUuid=it.pkgUuid, entry.layQty=1"
                  >
                    <a class="font12">
                      <strong style="color:#f03;">1</strong>&nbsp;
                      <span style="color:#333;">件</span>
                      <span style="margin-top:5px;display:block;">自定义</span>
                      <span>件数</span>
                    </a>
                  </div>
                </Slider>
              </div>
            </div>
            <div class="price money">
              <div class="float-left">
                <strong>
                  <span>单价&nbsp;</span>
                  <span style="color:#f03">￥{{it.price | toMoney}}</span>
                </strong>
                <span>
                  &nbsp;×
                  <strong>{{entry.layQty * qty}}</strong>
                  &nbsp;
                  {{it.pkgLayQtyUnit}}
                </span>
                <span style="margin-left:50px;">金额</span>
                <strong style="color:#f03">&nbsp;￥{{multiply(it.price, entry.layQty * qty) | toMoney}}</strong>
              </div>
              <div class="float-right">
                <button class="ap-btn-darkred cancle" @click="it.showPkg = false">取消</button>
                <button class="ap-btn-darkred add" @click="addToCart(it), it.showPkg = false">加入采购车</button>
              </div>
            </div>
          </div>
        </div>
        <NoResule v-if="records.length==0"></NoResule>
      </div>
    </div>

    <AddToListDialog :commodity="addListItem" v-if="showAddToListDialog" @close="showAddToListDialog=false"></AddToListDialog>
  </div>
</template>

<script>
import InputNumber from "@components/InputNumber.vue";
import * as utils from "@common/utils";
import Slider from "@components/Slider.vue";
import NoResule from "./components/NoResult.vue";
import AddToListDialog from "./components/AddToListDialog.vue";

export default {
  components: {
    InputNumber,
    Slider,
    NoResule,
    AddToListDialog
  },
  data() {
    return {
      pageIndex: 1,
      oeNumber: "",
      type: "",
      dispWord: "",
      records: [],
      brands: [],
      brandIds: [],
      genCmdties: [],
      genCmdtyIds: [],
      entry: {
        commodityId: "",
        pkgUuid: "",
        layQty: 1
      },
      qty: 1,
      showAddToListDialog: false,
      addListItem: {}
    };
  },
  computed: {
    keyword() {
      return this.$route.params.keyword;
    }
  },
  created() {
    this.oeNumber = this.$route.query.oeNumber;
    this.type = this.$route.query.type;
    if (this.oeNumber && this.type) {
      let queryNumbers = [];
      queryNumbers.push(this.oeNumber);
      let query = {
        type: this.type,
        numbers: queryNumbers
      };
      this.aggByRefNum(query);
      document.title = '51 AUTOPARTS "' + this.oeNumber + '"' + " 搜索结果";
    } else if (this.keyword) {
      this.aggByKeyword(this.keyword);
      document.title = '51 AUTOPARTS "' + this.keyword + '"' + " 搜索结果";
    }
    this.search();
  },
  methods: {
    search() {
      if (this.oeNumber && this.type) {
        let queryNumbers = [];
        queryNumbers.push(this.oeNumber);
        let query = {
          type: this.type,
          numbers: queryNumbers
        };
        if (this.brandIds.length > 0) {
          query.brandSourceIds = this.brandIds;
        }
        if (this.genCmdtyIds.length > 0) {
          query.genCmdtySourceIds = this.genCmdtyIds;
        }
        this.queryByRefNum(query);
      } else if (this.keyword) {
        this.queryByKeyword();
      }
    },
    getChildren(it, brand) {
      brand.show = !brand.show;
      if (!brand.show) return; // 折叠起来时不请求数据
      if (brand.children.length) return; // 有数据了就不再次请求
      let params = {
        commodityEsId: it.id,
        brandSourceId: brand.sourceId
      };
      this.$post("/dmhs/commodities/getVehLkgs", params)
        .then(res => {
          let temp = {}; // 去除相同车型
          res = res.reduce((curs, next) => {
            if (!temp[next.modelSourceId]) {
              temp[next.modelSourceId] = true;
              curs.push(next);
            }
            return curs;
          }, []);
          brand.children = res;
        })
        .catch(err => {});
    },
    queryByRefNum(args) {
      let vm = this;
      this.$list("/dmhs/commodities/selectByRefNum", args)
        .then(res => {
          let commodityIds = [];
          Object.values(res)[0].forEach(x => {
            x.showPkg = false;
            x.price = ""; // 价格与商品分离了，清空原来商品里的价格。
            commodityIds.push(x.sourceId); // 通过commodityIds来查询价格
            if (Array.isArray(x.vehBrdLinkageList)) {
              x.vehBrdLinkageList.forEach(it => {
                it.show = false;
                it.children = [];
              });
            } else {
              x.vehBrdLinkageList = [];
            }
          });
          vm.records = Object.values(res)[0];
          this.dispWord = this.oeNumber;
          if (!commodityIds.length) return [];
          return this.$post("/crms/salesQuotation/current", { commodityIds });
        })
        .then(res => {
          res.forEach(it1 => {
            this.records.forEach(it2 => {
              if (it1.commodityId == it2.sourceId) it2.price = it1.salesPrice;
            });
          });
        });
    },
    queryByKeyword(args) {
      let vm = this;
      args = args || {
        limit: this.$limit,
        offset: 0,
        criteria: {}
      };
      args.criteria.keyword = this.keyword;
      if (this.brandIds.length > 0) {
        args.criteria.brandSourceIds = this.brandIds;
      }
      if (this.genCmdtyIds.length > 0) {
        args.criteria.genCmdtySourceIds = this.genCmdtyIds;
      }
      this.$list("/dmhs/commodities/queryByKeyword", args)
        .then(res => {
          let commodityIds = [];
          res.results.forEach(x => {
            x.showPkg = false;
            x.price = ""; // 价格与商品分离了，清空原来商品里的价格。
            commodityIds.push(x.sourceId); // 通过commodityIds来查询价格
            if (Array.isArray(x.vehBrdLinkageList)) {
              x.vehBrdLinkageList.forEach(it => {
                it.show = false;
                it.children = [];
              });
            } else {
              x.vehBrdLinkageList = [];
            }
          });
          this.dispWord = this.keyword;
          vm.records = res.results;
          if (!commodityIds.length) return [];
          return this.$post("/crms/salesQuotation/current", { commodityIds });
        })
        .then(res => {
          res.forEach(it1 => {
            this.records.forEach(it2 => {
              if (it1.commodityId == it2.sourceId) it2.price = it1.salesPrice;
            });
          });
        });
    },
    aggByKeyword(keyword) {
      this.$list(
        "dmhs/commodities/aggByKeyword",
        { keyword: keyword },
        {
          success(res) {
            this.brands = res.brandAgg;
            this.genCmdties = res.genCmdtyAgg;
          }
        }
      );
    },
    aggByRefNum(args) {
      this.$list("dmhs/commodities/aggByRefNum", args, {
        success(res) {
          this.brands = res.brandAgg;
          this.genCmdties = res.genCmdtyAgg;
        }
      });
    },
    showPkg(id) {
      this.records.forEach(x => {
        if (x.id == id) {
          x.showPkg = true;
        } else {
          x.showPkg = false;
        }
      });
    },
    initCart(it) {
      this.qty = 1;
      this.entry.commodityId = it.id;
      if (it.loadingPackagingList && it.loadingPackagingList.length > 0) {
        this.entry.pkgUuid = it.loadingPackagingList[0].uuid;
        this.entry.layQty = it.loadingPackagingList[0].layQty;
      } else {
        this.entry.pkgUuid = it.pkgUuid;
        this.entry.layQty = 1;
      }
    },
    addToCart(it) {
      this.$store.commit("changeCart", [
        {
          fileUri: it.documentList && it.documentList[0] ? this.getImgUrl(it.documentList[0].fileUri) : "",
          name: it.name,
          price: it.price,
          layQty: this.entry.layQty,
          qty: this.qty
        }
      ]);
      let params = {
        id: this.entry.commodityId,
        pkgUuid: this.entry.pkgUuid,
        qty: this.qty
      };
      this.$post("bhome/carts/save", params)
        .then(() => {
          clearTimeout(window.cartTimeoutId);
          this.$store.commit("changeShowCart", true);
          window.cartTimeoutId = setTimeout(() => {
            this.$store.commit("changeShowCart", false);
          }, 3000);
        })
        .catch(err => {});
    },
    addToList(it) {
      this.addListItem = it;
      this.showAddToListDialog = true;
    },
    multiply(arg1, arg2) {
      return utils.multiply(arg1, arg2);
    }
  }
};
</script>

<style lang="less">
.ap-number-search-single {
  padding-top: 10px;
  margin-bottom: 30px;
  .filter-wrap {
    margin-bottom: 30px;
    .item {
      margin-bottom: 15px;
      .custom-control-label::before {
        border-radius: 0px;
        border: 2px solid #c6c9d5;
      }
      .form-control {
        height: 30px;
        border-radius: 0px;
        border: 2px solid #c6c9d5;
        &:focus {
          box-shadow: none;
        }
      }
      .tit {
        font-size: 12px;
        margin-bottom: 8px;
      }
    }
    .ap-btn-red {
      font-weight: 700;
      font-size: 12px;
      line-height: 22px;
    }
  }
  .prod-item {
    overflow: hidden;
    padding: 30px 0;
    position: relative;
    border-bottom: 1px solid #e4e4e4;
    .col-img {
      width: 160px;
      height: 160px;
      margin-right: 20px;
      .img {
        width: 100%;
        max-height: 100%;
      }
    }
    .number {
      font-weight: bold;
      font-size: 20px;
      padding: 0 100px 10px 160px;
      a {
        color: #f03;
      }
    }
    .col-number {
      width: 235px;
      .brand {
        margin-bottom: 10px;
      }
      .genart,
      .r90 {
        font-size: 12px;
      }
    }
    .col-props {
      width: 250px;
      font-size: 12px;
      .prop-item {
        margin-bottom: 3px;
        span,
        strong {
          display: inline-block;
        }
        span {
          color: #666;
        }
        strong {
          margin-left: 8px;
        }
      }
    }
    .col-actions {
      position: absolute;
      top: 30px;
      right: 0;
      text-align: right;
      width: 180px;
      .add-car {
        width: 100px;
        height: 32px;
      }
      .add-list {
        width: 100px;
        height: 32px;
        margin-top: 15px;
        color: #333;
        background: #fff;
        border: 1px solid rgb(204, 204, 204);
        &:hover {
          background: #f2f2f2;
          border: 1px solid #f2f2f2;
        }
      }
      .price {
        color: #f03;
        font-weight: bold;
        font-size: 1rem;
      }
      button {
        margin-top: 10px;
        width: 70%;
        font-size: 12px;
        font-weight: bold;
      }
    }
  }
}
.picked {
  cursor: pointer;
  background: #e4e4e4 !important ;
}
.package-info {
  float: right;
  width: 590px;
  position: relative;
  > a {
    display: inline-block;
    padding: 8px 10px;
    min-width: 90px;
    border: 1px solid #e4e4e4;
    strong {
      color: #f03;
      font-size: 1rem;
    }
    span {
      color: #666;
      + span {
        display: block;
      }
    }
    + a {
      margin-left: -1px;
    }
    &:hover {
      background: #f2f2f2;
    }
  }
  > div {
    display: inline-block;
    padding: 8px 18px 11px;
    margin-left: 10px;
    border: 1px solid #e4e4e4;
    background: #f2f2f2;
    vertical-align: top;
  }
}
.add-to-car {
  span,
  button {
    display: inline-block;
    vertical-align: top;
  }
  button {
    width: 110px;
    font-size: 14px;
  }
}
</style>

<style lang="less" scoped>
.package-info {
  .tit-wrap {
    margin: 0;
    position: relative;
    overflow: hidden;
    height: 20px;
  }
  .title {
    color: #666;
    position: absolute;
    left: 0;
    top: 0;
    font-size: 12px !important;
  }
  .count-title {
    color: #666;
    position: absolute;
    right: 120px;
    top: 0;
    font-size: 12px !important;
    font-weight: bold;
  }
  .count {
    margin: 0;
    padding: 1px;
    float: right;
    width: 170px;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .wrapper {
    float: left;
    width: 400px;
    border: none;
    background: #fff;
    padding: 0;
    margin: 0;
    .single,
    .multi {
      width: 100px;
      height: 90px;
      text-align: center;
      float: left;
      border: 1px solid #e4e4e4;
      padding: 5px;
    }
  }
}
.money {
  float: right;
  padding-top: 30px;
  width: 560px;
  .cancle {
    width: 80px;
    height: 36px;
    font-size: 14px;
    background: #fff;
    color: #333;
    border: 1px solid #e4e4e4;
  }
  .add {
    width: 110px;
    height: 36px;
    font-size: 14px;
    font-weight: 700;
    margin-left: 10px;
    background: #ff0101;
  }
  .float-left {
    line-height: 40px;
  }
}
.filter-item {
  .out {
    font-weight: bolder;
    cursor: pointer;
    .out-tit {
      padding: 3px;
      &:hover {
        background: #f6f7f9;
      }
      .img {
        vertical-align: middle;
        margin-right: 8px;
      }
      .text {
        vertical-align: middle;
      }
    }
    .inner {
      .inner-tit {
        padding: 3px;
        margin-left: 30px;
        font-weight: normal;
        &:hover {
          color: #f03;
          background: #f6f7f9;
        }
      }
    }
  }
  .active {
    color: #f03;
    background: #f6f7f9;
  }
}
</style>